import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { ImportDeconstructionSymbols } from './ImportDeconstructionSymbols.js';
import { StringLiteral } from './StringLiteral.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class ImportDeconstruction extends SlangNode {
  readonly kind = NonterminalKind.ImportDeconstruction;

  symbols: ImportDeconstructionSymbols;

  path: StringLiteral;

  constructor(ast: ast.ImportDeconstruction, collected: CollectedMetadata) {
    super(ast, collected);

    this.symbols = new ImportDeconstructionSymbols(ast.symbols, collected);
    this.path = new StringLiteral(ast.path, collected);

    this.updateMetadata(this.symbols, this.path);
  }

  print(print: PrintFunction): Doc {
    return ['{', print('symbols'), '} from ', print('path')];
  }
}
